export const catalogFields = [
  {
    name: "catalogChannelId",
    label: "Catalog Channel ID",
    type: "text",
    required: true,
  },
  {
    name: "channelSkuId",
    label: "Channel SKU ID",
    type: "text",
    required: true,
  },
  {
    name: "itemName",
    label: "Item Name",
    type: "skuPicker",
    required: true,
  },
  {
    name: "brand",
    label: "Brand",
    type: "text",
  },
  {
    name: "color",
    label: "Color",
    type: "text",
  },
  {
    name: "size",
    label: "Size",
    type: "text",
  },
  {
    name: "category",
    label: "Category",
    type: "text",
  },
  {
    name: "subCategory",
    label: "Sub Category",
    type: "text",
  },
  {
    name: "shipmentMethod",
    label: "Shipment Method",
    type: "select",
    options: ["Self Ship", "Ship by Channel"],
  },
  {
    name: "shippingSpeed",
    label: "Shipping Speed",
    type: "select",
    options: ["Express", "Standard"],
  },
];
